import { render, staticRenderFns } from "./changeTab.vue?vue&type=template&id=0820efbb&"
import script from "./changeTab.vue?vue&type=script&lang=js&"
export * from "./changeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports